
import mediaApi from "../api/MediaApi";
import MediaFileInfo from "../model/MediaFileInfo";

type Props = { 
    file: MediaFileInfo
}

const FileDownloadLink = ({ file }: Props) => {

    const downloadFile = (e:any) => {
        e.preventDefault();
        var tpl: string = process.env.REACT_APP_FILE_URL_TEMPLATE!;

        //Set the File URL.
        var fileUrl = tpl.replace('{id}', '' + file.id!);;
        mediaApi.getFileBlobByUrl(fileUrl)
            .then((binaryData:any) => {
                var isIE = false || !!(document as any).documentMode;
                if (isIE) {
                    (window as any).navigator.msSaveBlob(binaryData, file.name);
                } else {
                    console.log(binaryData)
                    var url = window.URL || window.webkitURL;
                    // var link = window.URL.createObjectURL(new Blob([new TextEncoder().encode(binaryData)], {type: file.contentType}));
                    var link = window.URL.createObjectURL(new Blob([binaryData], {type: file.contentType}));
                    var a = document.createElement("a");
                    a.setAttribute("download", file.name!);
                    a.setAttribute("href", link);
                    a.setAttribute("target", "_blank");
                    document.body.appendChild(a);
                    a.click();
                    document.body.removeChild(a);
                    url.revokeObjectURL(link);
                }
            })
            
            .catch(e => {
                console.log(e)
            });
        return false;
    };

    return (
        <>
            {file.id ? <a href="/#" onClick={downloadFile}>{file.name}</a> : ""}
        </>
    )
}

export default FileDownloadLink;